
<app-dialog-content [title]="DELETE_TITLE_LOCALIZED">

    <div class="content">
        <!-- Logo -->
        <img width="50px" height="50px" src="./assets/warning.svg" alt="RemoveWarning">
        <!-- Description -->
        <span i18n="Delete confirmation message|Translation for delete confirmation message@@DeleteKeywordConfirmationMessage">
            Are you sure you want to delete this glossary? Once the definition is deleted, it will no longer be displayed in the associated applications.
        </span>
    </div>

    <!-- Action Buttons -->
    <ng-container uiDialogActions>
        <button mat-flat-button (click)="confirm()" >
            {{DELETE_TITLE_LOCALIZED}}
        </button>
        <button mat-flat-button color="primary" (click)="cancel()" i18n="Cancel label|Label text for Cancel button@@Cancel">
            Cancel
        </button>
    </ng-container>
</app-dialog-content>
